<template>
  <div class="container-fluid px-0">
    <div class="row mb-4 g-2" :dir="locale === 'ar' ? 'rtl' : 'ltr'">
      <!-- Search -->
      <div class="col-12 col-md-8 position-relative">
        <input
          type="text"
          class="form-control form-control-sm"
          :class="locale === 'ar' ? 'ps-5' : 'pe-5'"
          :placeholder="t('common.search')"
          v-model="localSearch"
          @keyup.enter="flushSearch"
          @blur="flushSearch"
        />
        <span
          class="position-absolute top-50 translate-middle-y"
          :class="locale === 'ar' ? 'start-0 ps-3' : 'end-0 pe-3'"
        >
          <i class="fas fa-search"></i>
        </span>
      </div>

      <div class="col-12 col-md-4">
        <button
          class="btn btn-primary btn-sm w-100"
          @click="$emit('add')"
          v-can="'areas.create'"
        >
          <i class="fas fa-plus me-1"></i>
          {{ t('common.add') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits, defineExpose } from 'vue'
import { useI18n } from 'vue-i18n'

const { t, locale } = useI18n()

const props = defineProps({
  modelValue: { type: String, default: '' }
})
const emit = defineEmits(['update:modelValue', 'search', 'add'])

const localSearch = ref(props.modelValue)
watch(() => props.modelValue, v => { localSearch.value = v })

let timer = null
const debouncedSearch = () => {
  if (timer) clearTimeout(timer)
  timer = setTimeout(() => {
    emit('update:modelValue', localSearch.value)
    emit('search', localSearch.value.trim())
    timer = null
  }, 500)
}

watch(localSearch, () => {
  debouncedSearch()
})

const flushSearch = () => {
  if (timer) {
    clearTimeout(timer)
    timer = null
  }
  emit('update:modelValue', localSearch.value)
  emit('search', localSearch.value.trim())
}

const clearSearch = () => {
  localSearch.value = ''
  flushSearch()
}
defineExpose({ clearSearch })
</script>
